<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { useRuntimeStore } from '../stores/runtime'

const route = useRoute()
const store = useRuntimeStore()
const folderId = computed(() => String(route.params.folderId))
const folder = computed(() => store.navigation.folders.find(item => item.id === folderId.value))
const children = computed(() => store.navigation.folders.filter(item => item.parent_id === folderId.value).sort((a,b) => a.sort - b.sort))
const forms = computed(() => store.navigation.publications.filter(item => item.folder_id === folderId.value).sort((a,b) => a.sort - b.sort))
</script>

<template>
  <section>
    <nav class="breadcrumbs"><RouterLink to="/">Главная</RouterLink><span>›</span><span>{{ folder?.name || 'Папка' }}</span></nav>
    <div class="page-head"><div><h1>{{ folder?.name || 'Папка' }}</h1><p v-if="folder?.description">{{ folder.description }}</p></div></div>
    <div class="explorer-grid">
      <RouterLink v-for="item in children" :key="item.id" class="explorer-item folder" :to="`/folders/${item.id}`">
        <div class="explorer-icon">▰</div><div><strong>{{ item.name }}</strong><small>{{ item.description }}</small></div>
      </RouterLink>
      <RouterLink v-for="item in forms" :key="item.id" class="explorer-item form" :to="`/forms/${item.public_key}`">
        <div class="explorer-icon">▤</div><div><strong>{{ item.name }}</strong><small>{{ item.description }}</small></div>
      </RouterLink>
    </div>
  </section>
</template>
